import { render, staticRenderFns } from "./BoxLinks.vue?vue&type=template&id=6c51f4fe&"
import script from "./BoxLinks.vue?vue&type=script&lang=js&"
export * from "./BoxLinks.vue?vue&type=script&lang=js&"
import style0 from "./BoxLinks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/ojg15/Desktop/Programming/me-cfs-group-canterbury/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VLayout})
